export const HERO_VIDEOS = ["/videos/hero_wash_1.mp4", "/videos/hero_wash_2.mp4"];

export const BUSINESS = {
  name: "Everything Works Services",
  tagline: "Window Cleaning — Naperville, Illinois",
  phone: "630-909-3759",
  phoneHref: "tel:+16309093759",
  zellePhone: "331-204-2111",
  zelleEmail: "ahmadmalexa@gmail.com",
  reviewUrl: "https://www.google.com/maps/search/Everything+Works+Services+Naperville+IL",
  logo3d:
    "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/34210f86e29878081dde0a4cf8abbd1febee6fbbc4db6be483cb3c852a9d39ab.jpeg",
};

export const IMAGES = {
  heroClear:
    "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/fb1f0dc80da6a825a3eb92b4399a7d6b53b2b85f110fd454f368e076796946a2.jpeg",
  heroDirty:
    "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/7c764390d08cdf8f45089fe36e1cbdab8f47380f6354ea7ad645920d5c8c9ed4.jpeg",
  squeegee:
    "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/8a049275d7f278fde46c9e1c122d8e5a05ea3b722c6f8b7cae020df834d013cd.jpeg",
  storefront:
    "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/a7754922412676b56431775803a5cc9013d8cc18cda1d539ffa85eec3a629525.jpeg",
  uniform:
    "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/f102da218d606e7c45bf845bccb95c2026f344fcc8b93c51386645d9ffe8cb82.jpeg",
  realInterior:
    "https://images.unsplash.com/photo-1760624493021-b895835809ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMG1vZGVybiUyMGhvdXNlJTIwbGFyZ2UlMjB3aW5kb3dzJTIwaW50ZXJpb3IlMjBzdW5saWdodHxlbnwwfHx8fDE3OTIwNjI0MTJ8MA&ixlib=rb-4.1.0&q=85",
  realStorefront:
    "https://images.unsplash.com/photo-1769509456084-dacd3cde0e20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBib3V0aXF1ZSUyMHN0b3JlZnJvbnQlMjBnbGFzcyUyMHdpbmRvdyUyMGRpc3BsYXl8ZW58MHx8fHwxNzkyMDYyNDEyfDA&ixlib=rb-4.1.0&q=85",
  sceneHome:
    "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/979971f2e3773518252b7d37457def599069ad888d40299ed50ed602b3a96273.jpeg",
  sceneInterior:
    "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/1d2b1ba18ac0bb498368c0cfc0b8f5a772e20566970d8e6f239b383df0d6a098.jpeg",
  sceneStorefront:
    "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/8eaafe50ba71c95b31cad6a3940b5ffbacd11ea9e3409514f2ab9265c9f252de.jpeg",
};

export const PROJECTS = [
  {
    key: "residential",
    title: "Residential — one brick home, every window",
    cover: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/b444e1394af4c27b67f2cd1ad48814709d05745659b6306be2fcdc4abe91a2eb.jpeg",
    cardCaption: "Residential — 2 story brick home, full inside & out",
    items: [
      {
        type: "ba",
        key: "home",
        before:
          "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/f21779df30b8cd46f9da7398e4af9faa8222139733bcf0821843bd3e39779dee.jpeg",
        after:
          "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/84ac79702e4acaa21dbc8d5285fe645ba5a597107b6e10a023a4a05d0012c953.jpeg",
        caption: "The front windows — drag to compare",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/b444e1394af4c27b67f2cd1ad48814709d05745659b6306be2fcdc4abe91a2eb.jpeg",
        caption: "The whole house — every window glowing",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/e55a36b7fbd5138b32ce1c78dac4ee798d10827bed51ee54741a9bbfaf3ce869.jpeg",
        caption: "Front entry — sidelights detailed",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/10ed6ea940a15a22fa775fce3e24a37477c75e83658a20800c906c636f87573f.jpeg",
        caption: "Second-floor bedrooms — ladder work",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/28e553f4131552063a6fa20183b3cac69790c531b8d21a8ce8a2a32cdf3c34e5.jpeg",
        caption: "Back patio doors — inside & out",
      },
    ],
  },
  {
    key: "storefront",
    title: "Storefront — one boutique, glass to the sidewalk",
    cover: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/18d2a732c1861fd58619c42c4e757cf04b2cf655d64561f966349188862b27e2.jpeg",
    cardCaption: "Storefront — glass your customers can see through",
    items: [
      {
        type: "ba",
        key: "store",
        before:
          "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/b50ddb25f6e31e149ee9b0cc870185b1e1da105371059b4052a9497fae5605ee.jpeg",
        after:
          "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/79ea3528dab717405e787793bd96aeb82651398a36dbf0fe245c025c554b7a06.jpeg",
        caption: "The display glass — drag to compare",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/18d2a732c1861fd58619c42c4e757cf04b2cf655d64561f966349188862b27e2.jpeg",
        caption: "The full facade, spotless",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/f3db9834b1d67e6651ebb9bf917b6586c31765077055079199f56bfcb7547972.jpeg",
        caption: "Entry door — before customers arrive",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/70d61a32e943d9ed98aebd66eb4e6f1e00b3de60ecbae0f167e86551aff49759.jpeg",
        caption: "Left display — backlit art panels",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/e2c42be67a8e4064da671b290d70e32d6ee58c53e288385fc1306ae2748488ff.jpeg",
        caption: "From inside — invisible glass",
      },
    ],
  },
  {
    key: "interiors",
    title: "Interior — one kitchen, garden restored",
    cover: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/789c2603c972d6b255b006754e3f56770fdeffb95b99309cb5f14ed0426ea643.jpeg",
    cardCaption: "Interior pass — natural light, unobstructed",
    items: [
      {
        type: "ba",
        key: "interior",
        before:
          "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/6a15f4eb38e3f7af8df71288e4bc07f65c34bf23dcd07efbea9b5da01c6333f8.jpeg",
        after:
          "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/8595afed0a3e0b322091d1369f3b836388e193cf8c0bc827f3ad797489a335c8.jpeg",
        caption: "The kitchen window — drag to compare",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/789c2603c972d6b255b006754e3f56770fdeffb95b99309cb5f14ed0426ea643.jpeg",
        caption: "The full kitchen wall of glass",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/fcdfb159ee9083ec7a1f15d0ba42835d4abd1a4227ad666fe529b77d917470ef.jpeg",
        caption: "Living-room bay — same garden view",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/cef30bc2bd3431e0225dfb5549a5a3c382105a3954c511e8439dc860deadfe78.jpeg",
        caption: "Sill-level detail — nothing left behind",
      },
      {
        type: "photo",
        src: "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/ab3fa6891565d126a150f37bb5b387b7aebcccd0257543caf3e62ce5bc448dfa.jpeg",
        caption: "Dining room pass — morning light",
      },
    ],
  },
];

export const BEFORE_AFTER = [
  {
    key: "home",
    before:
      "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/f21779df30b8cd46f9da7398e4af9faa8222139733bcf0821843bd3e39779dee.jpeg",
    after:
      "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/84ac79702e4acaa21dbc8d5285fe645ba5a597107b6e10a023a4a05d0012c953.jpeg",
    caption: "2-story home — full inside & out",
  },
  {
    key: "store",
    before:
      "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/b50ddb25f6e31e149ee9b0cc870185b1e1da105371059b4052a9497fae5605ee.jpeg",
    after:
      "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/79ea3528dab717405e787793bd96aeb82651398a36dbf0fe245c025c554b7a06.jpeg",
    caption: "Boutique storefront — detailed before open",
  },
  {
    key: "interior",
    before:
      "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/6a15f4eb38e3f7af8df71288e4bc07f65c34bf23dcd07efbea9b5da01c6333f8.jpeg",
    after:
      "https://static.prod-images.emergentagent.com/jobs/cd28a7d7-b0c7-4042-82a2-33a900b3da2a/images/8595afed0a3e0b322091d1369f3b836388e193cf8c0bc827f3ad797489a335c8.jpeg",
    caption: "Interior pass — garden view restored",
  },
];

// Top-of-market Naperville rates (USD)
export const RATES = {
  res_1story: {
    key: "res_1story",
    label: "1-Story Home",
    kind: "residential",
    pane: { exterior: 10, inside_out: 14 },
    window: { exterior: 15, inside_out: 22 },
  },
  res_2story: {
    key: "res_2story",
    label: "2-Story Home",
    kind: "residential",
    pane: { exterior: 14, inside_out: 18 },
    window: { exterior: 24, inside_out: 32 },
  },
  storefront: {
    key: "storefront",
    label: "Storefront",
    kind: "commercial",
    pane: { inside_out: 12 },
    window: { inside_out: 20 },
    minimum: 75,
  },
};

export function calcTotal(serviceKey, unit, scope, count) {
  const r = RATES[serviceKey];
  const s = r.kind === "commercial" ? "inside_out" : scope;
  const rate = r[unit][s];
  return r.minimum ? Math.max(r.minimum, rate * count) : rate * count;
}

export const FREQUENCIES = [
  { key: "one_time", label: "One-time" },
  { key: "weekly", label: "Weekly" },
  { key: "biweekly", label: "Every 2 weeks" },
  { key: "monthly", label: "Monthly" },
];

export const PLAN_LENGTHS = [
  { months: 3, label: "3 months" },
  { months: 6, label: "6 months" },
  { months: 12, label: "12 months" },
];

export function frequencyLabel(key) {
  return { one_time: "One-time", weekly: "Weekly", biweekly: "Every 2 weeks", monthly: "Monthly" }[key] || "One-time";
}

export function visitsFor(frequency, planMonths) {
  if (!frequency || frequency === "one_time" || !planMonths) return 1;
  if (frequency === "monthly") return planMonths;
  if (frequency === "biweekly") return Math.round((planMonths * 26) / 12);
  if (frequency === "weekly") return Math.round((planMonths * 52) / 12);
  return 1;
}

export function planLabel(frequency, planMonths) {
  if (frequency === "one_time" || !planMonths) return "One-time";
  return `${frequencyLabel(frequency)} plan · ${planMonths} months (${visitsFor(frequency, planMonths)} visits)`;
}

export function monthlyEstimate(total, frequency) {
  if (frequency === "weekly") return Math.round((total * 52) / 12);
  if (frequency === "biweekly") return Math.round((total * 26) / 12);
  return null;
}

// Things around the glass — priced add-ons (premium end of market)
export const ADDONS = [
  { key: "screens", label: "Screens", desc: "washed both sides", price: 5, unit: "each" },
  { key: "tracks", label: "Tracks & sills", desc: "detailed", price: 4, unit: "each" },
  { key: "frames", label: "Frames & trim", desc: "hand-wiped", price: 3, unit: "each" },
  { key: "grids", label: "Grids / muntins", desc: "per section", price: 5, unit: "each" },
  { key: "skylights", label: "Skylights", desc: "", price: 40, unit: "each" },
  { key: "hardwater", label: "Hard-water stains", desc: "mineral removal", price: 12, unit: "per pane" },
  { key: "construction", label: "Post-construction", desc: "paint & residue", price: 25, unit: "per pane" },
];

export const EMPTY_ADDONS = {
  screens: 0, tracks: 0, frames: 0, grids: 0, skylights: 0, hardwater: 0, construction: 0,
};

export const calcAddons = (addons) =>
  ADDONS.reduce((s, a) => s + a.price * (addons[a.key] || 0), 0);

export const addonCount = (addons) =>
  ADDONS.reduce((s, a) => s + (addons[a.key] || 0), 0);

export const TIME_SLOTS = [
  "8:00 AM",
  "9:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "1:00 PM",
  "2:00 PM",
  "3:00 PM",
  "4:00 PM",
  "5:00 PM",
];
